import { render, staticRenderFns } from "./HelpCreate.vue?vue&type=template&id=420902bf&"
import script from "./HelpCreate.vue?vue&type=script&lang=js&"
export * from "./HelpCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports